import React from 'react';
import { StepTimeline } from '../../components';
import { AppHeader } from '../app-header';
import './health-assesment-calculator.scss'


export const HealthAssesmentCalculator = ({ children }) => {
  return (
    <section className="health-assesment-calculator">
      <div className="health-grade">
        <h6>Paystand AR Health Assessment <span className="beta--label">(Beta)</span></h6>
        <h1>Unlock Your AR Health Grade</h1>
        <p>The Paystand AR Health Assessment is designed to give you visibility into your company's financial health. See how you measure up within four main areas in Accounts Receivable and get actionable tips to keep your business healthy and efficient. Just fill out the following questions to receive your AR Health Assessment.</p>
      </div>

      <div className="container">
        <StepTimeline />

        <main>
          {children}
        </main>
      </div>
    </section>
  )
}
